import React from 'react'

import { BASE_URL, ICONS } from '../../constants'

import { useIncident } from '../hooks'
import { useCrimeCategory } from '../../crimeCategories/hooks'

import IncidentDate from '../../incidents/components/IncidentDate'

import styles from './IncidentListItem.module.css'

const IncidentListItem = ({ incidentId }) => {
  const [
    {
      incidentDate,
      incidentTypeDescription,
      location,
      crimeCategory,
      sentToPalmetto,
    },
    { select, onHover, onHoverEnd },
  ] = useIncident(incidentId)

  const category = useCrimeCategory(crimeCategory)

  return (
    <li
      className={sentToPalmetto ? `${styles.sent} ${styles.item}` : styles.item}
      onClick={select}
      onMouseEnter={onHover}
      onMouseLeave={onHoverEnd}
    >
      <img
        className={styles.icon}
        alt={category.name}
        src={BASE_URL + ICONS.BORDERLESS.DIR + category.icon}
      />
      <div className={styles.title}>{incidentTypeDescription}</div>
      <div className={styles.street}>{location}</div>
      <IncidentDate style={styles.timestamp} date={incidentDate} />
    </li>
  )
}
export default IncidentListItem
